// Header for Plan view (Cards / Gantt / Focus sub-views)
// Extracted from App.js

import React from 'react';
import { Menu, MessageCircle, ArrowLeft, Trophy } from 'lucide-react';
import { ABLE_COLORS } from '../constants';
import MabelLogo from './MabelLogo';
import UserMenu from './UserMenu';
import ReviewBadge from './ReviewBadge';

export default function ViewHeader({
  currentTime,
  tasks,
  pendingFactsCount,
  pendingAliasesCount,
  showMenu,
  user,
  onNavigate,
  onOpenActivityLog,
  onOpenReviewModal,
  onOpenChat,
  onOpenMemorySettings,
  onToggleMenu
}) {
  return (
    <div style={{
      background: 'white',
      borderRadius: '20px',
      padding: '20px 24px',
      marginBottom: '20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {/* Back button */}
        <button
          onClick={() => onNavigate('hub')}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            display: 'flex',
            alignItems: 'center'
          }}
          title="Back to Hub"
        >
          <ArrowLeft size={24} color={ABLE_COLORS.primary} />
        </button>
        <MabelLogo size={32} color={ABLE_COLORS.primary} />
        <div>
          <h1 style={{
            margin: 0,
            fontSize: '28px',
            color: ABLE_COLORS.primary,
            fontWeight: '700'
          }}>Mabel</h1>
          <p style={{
            margin: '4px 0 0 0',
            fontSize: '14px',
            color: ABLE_COLORS.textSecondary
          }}>
            Plan Mode
          </p>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        <div style={{
          fontSize: '13px',
          fontWeight: '600',
          color: ABLE_COLORS.textMuted
        }}>
          {currentTime.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
          })}
        </div>
        <div style={{
          fontSize: '13px',
          fontWeight: '600',
          color: ABLE_COLORS.textMuted
        }}>
          ·
        </div>
        <div style={{
          padding: '6px 12px',
          background: ABLE_COLORS.bgSubtle,
          borderRadius: ABLE_COLORS.radiusSmall,
          fontSize: '13px',
          fontWeight: '600',
          color: ABLE_COLORS.textSecondary
        }}>
          {tasks.length} total task{tasks.length === 1 ? '' : 's'}
        </div>
        <button
          onClick={onOpenActivityLog}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            display: 'flex',
            alignItems: 'center'
          }}
          title="Activity Log"
        >
          <Trophy size={24} color={ABLE_COLORS.accent} />
        </button>
        <ReviewBadge
          count={pendingFactsCount + pendingAliasesCount}
          onClick={onOpenReviewModal}
        />
        <button
          onClick={onOpenChat}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
          title="Chat with AI"
        >
          <MessageCircle size={24} color={ABLE_COLORS.primary} />
        </button>
        <UserMenu user={user} onOpenMemorySettings={onOpenMemorySettings} />
        <button
          onClick={onToggleMenu}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px'
          }}
        >
          <Menu size={24} color={ABLE_COLORS.primary} />
        </button>
      </div>
    </div>
  );
}
